/* Bundle widget: <volume-bundle> custom element.
   Moved out of main-product-bundle.liquid to stay under Shopify's 256 KB
   section-file limit. Contains no Liquid — all per-section values arrive via
   data-* attributes on the element. */
if (!customElements.get('volume-bundle')) {
           customElements.define(
            'volume-bundle',
            class VolumeBundle extends HTMLElement {
             connectedCallback() {
              this.formId = this.dataset.formId;
              this.sectionId = this.dataset.sectionId;
              this.moneyFormat = this.dataset.moneyFormat || '${' + '{amount}}';
              this.syncQuantity = this.dataset.syncQuantity !== 'false';

              // Draft preview: with ?bundle_preview=1, show the draft offer set
              // instead of live/manual; otherwise drop draft markup entirely.
              var previewMode = /[?&]bundle_preview=1/.test(window.location.search);
              var draftSet = this.querySelector('[data-vb-draft-set]');
              var liveSet = this.querySelector('[data-vb-live-set]');
              if (previewMode && draftSet) {
               if (liveSet) liveSet.remove();
               draftSet.classList.remove('volume-bundle__set--draft');
               var note = document.createElement('div');
               note.className = 'volume-bundle__preview-note';
               note.textContent = 'PREVIEW — draft offers. Checkout prices are NOT applied until published.';
               this.insertBefore(note, this.firstChild);
              } else if (draftSet) {
               draftSet.remove();
              }

              this.tiers = Array.from(this.querySelectorAll('[data-vb-tier]'));
              if (!this.tiers.length) {
               this.style.display = 'none';
               return;
              }

              try {
               var raw = this.querySelector('[data-vb-variants]');
               this.variants = raw ? JSON.parse(raw.textContent) : [];
              } catch (e) {
               this.variants = [];
              }

              var self = this;
              this.tiers.forEach(function (tier) {
               var main = tier.querySelector('[data-vb-tier-main]') || tier;
               main.addEventListener('click', function () {
                self.select(tier);
               });
               var radio = tier.querySelector('input[type="radio"]');
               if (radio) {
                radio.addEventListener('change', function () {
                 self.select(tier);
                });
               }
               // Keep upsell checkbox clicks from bubbling into tier selection.
               tier.querySelectorAll('[data-vb-upsell]').forEach(function (upsell) {
                upsell.addEventListener('click', function (event) {
                 event.stopPropagation();
                });
               });
              });

              // Hide offers outside their schedule window (covers cached pages;
              // the discount Function enforces the same window at checkout).
              this.applySchedule();

              // Select the default tier on load. An offer flagged
              // "Selected by default" (data-default) wins; otherwise the
              // block's positional "Pre-selected offer" setting applies.
              var self2 = this;
              var defaultTier = this.tiers.find(function (t) {
               return t.dataset.default === 'true' && self2.selectable(t);
              });
              if (!defaultTier) {
               var defaultIndex = parseInt(this.dataset.defaultTier, 10) || 1;
               defaultTier = this.tiers[defaultIndex - 1] || this.tiers[0];
              }
              if (defaultTier && !this.selectable(defaultTier)) {
               defaultTier = this.tiers.find(this.selectable.bind(this));
              }
              if (defaultTier) this.select(defaultTier, true);

              this.initCountdown();
              this.watchVariantChanges();
              this.patchFetchForUpsell();
             }

             selectable(tier) {
              return tier.dataset.oos !== 'true' && tier.dataset.scheduledOut !== 'true';
             }

             applySchedule() {
              var now = new Date();
              var today =
               now.getFullYear() * 10000 + (now.getMonth() + 1) * 100 + now.getDate();
              this.tiers.forEach(function (tier) {
               var start = parseInt(tier.dataset.start, 10) || 0;
               var end = parseInt(tier.dataset.end, 10) || 0;
               if ((start && today < start) || (end && today > end)) {
                tier.dataset.scheduledOut = 'true';
                tier.style.display = 'none';
               }
              });
             }

             initCountdown() {
              var bar = this.querySelector('[data-vb-countdown]');
              if (!bar) return;
              var timerEl = bar.querySelector('[data-vb-countdown-timer]');
              var end;
              // Preferred: absolute epoch computed at render in the
              // SHOP's timezone — identical moment for all visitors.
              var epoch = parseInt(bar.dataset.endEpoch, 10);
              if (epoch > 0) {
               end = epoch * 1000;
              } else {
               // Fallback: parse in the visitor's local time.
               var raw = (bar.dataset.end || '').trim().replace(' ', 'T');
               if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) raw += 'T23:59:59';
               end = new Date(raw).getTime();
              }
              if (!end || isNaN(end)) {
               bar.style.display = 'none';
               return;
              }
              var pad = function (n) {
               return (n < 10 ? '0' : '') + n;
              };
              var tick = function () {
               var diff = end - Date.now();
               if (diff <= 0) {
                bar.style.display = 'none';
                clearInterval(interval);
                return;
               }
               var days = Math.floor(diff / 86400000);
               var hours = Math.floor((diff % 86400000) / 3600000);
               var mins = Math.floor((diff % 3600000) / 60000);
               var secs = Math.floor((diff % 60000) / 1000);
               timerEl.textContent =
                (days > 0 ? days + 'd ' : '') + pad(hours) + ':' + pad(mins) + ':' + pad(secs);
              };
              tick();
              var interval = setInterval(tick, 1000);
             }

             select(tier, isInitial) {
              if (!this.selectable(tier)) return;
              this.tiers.forEach(function (t) {
               t.classList.remove('is-selected');
               var r = t.querySelector('input[type="radio"]');
               if (r) r.checked = false;
              });
              tier.classList.add('is-selected');
              var radio = tier.querySelector('input[type="radio"]');
              if (radio) radio.checked = true;

              if (this.syncQuantity) {
               this.setFormQuantity(parseInt(tier.dataset.quantity, 10) || 1);
              }

              // Optional: pre-apply a discount code so checkout matches the
              // displayed tier price. Codes persist for the session once applied,
              // so automatic discounts are the preferred setup.
              if (!isInitial && tier.dataset.discountCode) {
               var root =
                window.Shopify && window.Shopify.routes && window.Shopify.routes.root
                 ? window.Shopify.routes.root
                 : '/';
               fetch(root + 'discount/' + encodeURIComponent(tier.dataset.discountCode)).catch(
                function () {}
               );
              }
             }

             findQuantityInput() {
              // Try Dawn's id, then the form-associated input, then any
              // quantity input inside the product form this widget belongs to.
              var input =
               document.getElementById('Quantity-' + this.sectionId) ||
               document.querySelector('input[name="quantity"][form="' + this.formId + '"]');
              if (input) return input;
              var form =
               (this.formId && document.getElementById(this.formId)) ||
               this.closest('form') ||
               (this.closest('.product, .product-form, [data-product], product-info, main') || document)
                .querySelector('form[action*="/cart/add"]');
              if (form) {
               input =
                form.querySelector('input[name="quantity"]') ||
                form.querySelector('[name="quantity"]') ||
                form.querySelector('quantity-input input, .quantity__input');
               if (input) return input;
              }
              // Last resort: any quantity input on the page.
              return document.querySelector('input[name="quantity"]');
             }

             setFormQuantity(qty) {
              var input = this.findQuantityInput();
              if (!input) return;
              input.value = qty;
              // Fire both events; themes listen to one or the other.
              input.dispatchEvent(new Event('input', { bubbles: true }));
              input.dispatchEvent(new Event('change', { bubbles: true }));
             }

             // Quantity of the main product for the selected tier (min quantity).
             getSelectedQuantity() {
              var selected = this.querySelector('[data-vb-tier].is-selected');
              if (!selected) return 1;
              return parseInt(selected.dataset.quantity, 10) || 1;
             }

             // Returns an array of { id, quantity } that must be added to the
             // cart alongside the main product for the selected tier: combo
             // bundle products plus a checked upsell add-on.
             getExtraCartItems() {
              var selected = this.querySelector('[data-vb-tier].is-selected');
              if (!selected) return [];
              var items = [];

              if (selected.dataset.comboItems) {
               try {
                var combo = JSON.parse(selected.dataset.comboItems);
                if (Array.isArray(combo)) {
                 combo.forEach(function (item) {
                  if (item && item.id) {
                   items.push({ id: parseInt(item.id, 10), quantity: parseInt(item.quantity, 10) || 1 });
                  }
                 });
                }
               } catch (e) {
                /* noop */
               }
              }

              selected.querySelectorAll('[data-vb-upsell]').forEach(function (upsell) {
               var checkbox = upsell.querySelector('[data-vb-upsell-checkbox]');
               var id = parseInt(upsell.dataset.upsellVariantId, 10);
               if (checkbox && checkbox.checked && !checkbox.disabled && id) {
                items.push({ id: id, quantity: parseInt(upsell.dataset.upsellQty, 10) || 1 });
               }
              });
              return items;
             }

             getCurrentVariantId() {
              var form = document.getElementById(this.formId);
              var idInput = form ? form.querySelector('input[name="id"]') : null;
              return idInput ? String(idInput.value) : '';
             }

             // Piggyback on any /cart/add request for this product's variant and
             // add the checked upsell variant first — same pattern as the payment
             // options gift add-on, so the theme's cart drawer flow stays intact.
             patchFetchForUpsell() {
              if (window.__vbUpsellFetchPatched) return;
              window.__vbUpsellFetchPatched = true;

              function vbExtractFromBody(body, key) {
               try {
                if (!body) return null;
                if (typeof FormData !== 'undefined' && body instanceof FormData) return body.get(key);
                if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) return body.get(key);
                if (typeof body === 'string') {
                 if (body.charAt(0) === '{') {
                  var json = JSON.parse(body);
                  if (json[key] != null) return json[key];
                  if (json.items && json.items[0] && json.items[0][key] != null) return json.items[0][key];
                  return null;
                 }
                 var match = body.match(new RegExp('(?:^|&)' + key + '=([^&]+)'));
                 if (match) return decodeURIComponent(match[1]);
                }
               } catch (e) {
                /* noop */
               }
               return null;
              }

              var vbOrigFetch = window.fetch.bind(window);
              var vbInFlight = false;
              var vbRootUrl =
               window.Shopify && window.Shopify.routes && window.Shopify.routes.root
                ? window.Shopify.routes.root
                : '/';

              // Force the main product's quantity in an outgoing /cart/add body,
              // regardless of body type. Returns the (possibly new) body value.
              function vbForceQuantity(body, qty) {
               try {
                if (typeof FormData !== 'undefined' && body instanceof FormData) {
                 body.set('quantity', String(qty));
                 return body;
                }
                if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
                 body.set('quantity', String(qty));
                 return body;
                }
                if (typeof body === 'string' && body.length) {
                 if (body.charAt(0) === '{') {
                  var json = JSON.parse(body);
                  if (json.items && json.items[0]) {
                   json.items[0].quantity = qty;
                  } else {
                   json.quantity = qty;
                  }
                  return JSON.stringify(json);
                 }
                 if (body.indexOf('quantity=') !== -1) {
                  return body.replace(/quantity=[^&]*/, 'quantity=' + qty);
                 }
                 return body + '&quantity=' + qty;
                }
               } catch (e) {
                /* leave body unchanged */
               }
               return body;
              }

              // Some themes add to cart via XMLHttpRequest rather than fetch.
              // Patch send() to rewrite the quantity on /cart/add bodies.
              if (typeof XMLHttpRequest !== 'undefined' && !XMLHttpRequest.prototype.__vbPatched) {
               XMLHttpRequest.prototype.__vbPatched = true;
               var vbOpen = XMLHttpRequest.prototype.open;
               var vbSend = XMLHttpRequest.prototype.send;
               XMLHttpRequest.prototype.open = function (method, url) {
                this.__vbUrl = url || '';
                return vbOpen.apply(this, arguments);
               };
               XMLHttpRequest.prototype.send = function (body) {
                try {
                 if (this.__vbUrl && this.__vbUrl.indexOf('/cart/add') !== -1 && !vbInFlight) {
                  var widget = document.querySelector('volume-bundle');
                  if (widget) {
                   var mainId = vbExtractFromBody(body, 'id');
                   if (mainId != null && String(mainId) === widget.getCurrentVariantId()) {
                    var qty = widget.getSelectedQuantity();
                    arguments[0] = vbForceQuantity(body, qty);
                    // Fire extra items (combo/upsell) as a separate call.
                    var extra = widget.getExtraCartItems();
                    if (extra.length) {
                     vbOrigFetch(vbRootUrl + 'cart/add.js', {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                      body: JSON.stringify({ items: extra })
                     }).catch(function () {});
                    }
                    return vbSend.call(this, arguments[0]);
                   }
                  }
                 }
                } catch (e) {
                 /* fall through */
                }
                return vbSend.apply(this, arguments);
               };
              }

              window.fetch = function (input, init) {
               try {
                var url = typeof input === 'string' ? input : (input && input.url) || '';

                if (url.indexOf('/cart/add') !== -1 && !vbInFlight) {
                 var widget = document.querySelector('volume-bundle');
                 if (widget) {
                  var body = init ? init.body : input && input.body;
                  var mainId = vbExtractFromBody(body, 'id');

                  // Only act when this cart/add is for the bundle's own product
                  // variant (ignores quick-add of recommendations, etc.)
                  if (mainId != null && String(mainId) === widget.getCurrentVariantId()) {
                   var qty = widget.getSelectedQuantity();
                   var extraItems = widget.getExtraCartItems();

                   // Rewrite the main add to carry the tier quantity. Only
                   // init.body can be safely replaced; string/FormData/params
                   // are all handled by vbForceQuantity.
                   var newInit = init;
                   if (init && init.body != null) {
                    newInit = {};
                    for (var k in init) { if (Object.prototype.hasOwnProperty.call(init, k)) newInit[k] = init[k]; }
                    newInit.body = vbForceQuantity(init.body, qty);
                   }

                   if (extraItems.length) {
                    vbInFlight = true;
                    return vbOrigFetch(vbRootUrl + 'cart/add.js', {
                     method: 'POST',
                     headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                     body: JSON.stringify({ items: extraItems })
                    })
                     .catch(function () {})
                     .then(function () {
                      return vbOrigFetch(input, newInit);
                     })
                     .finally(function () {
                      vbInFlight = false;
                     });
                   }
                   // Plain volume tier: just the quantity-forced main add.
                   return vbOrigFetch(input, newInit);
                  }
                 }
                }
               } catch (e) {
                /* fall through to the original request */
               }
               return vbOrigFetch(input, init);
              };
             }

             watchVariantChanges() {
              var self = this;

              // Preferred: Dawn's pub/sub variant change event.
              if (window.subscribe && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.variantChange) {
               subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
                var variant = event && event.data && event.data.variant;
                if (variant) self.recalculate(variant.id);
               });
               return;
              }

              // Fallback: watch the product form's variant id input.
              var form = document.getElementById(this.formId);
              var idInput = form ? form.querySelector('input[name="id"]') : null;
              if (!idInput) return;
              new MutationObserver(function () {
               self.recalculate(idInput.value);
              }).observe(idInput, { attributes: true, attributeFilter: ['value'] });
              idInput.addEventListener('change', function () {
               self.recalculate(idInput.value);
              });
             }

             recalculate(variantId) {
              var variant = this.variants.find(function (v) {
               return String(v.id) === String(variantId);
              });
              if (!variant) return;

              var unitPrice = variant.price;
              var unitCompare = variant.price;
              var variantAvailable = variant.available !== false;
              var self = this;

              this.tiers.forEach(function (tier) {
               // Volume tiers follow the selected variant's availability;
               // combo OOS is member-driven and set server-side.
               if (!tier.dataset.comboItems) {
                if (variantAvailable) {
                 delete tier.dataset.oos;
                } else {
                 tier.dataset.oos = 'true';
                }
                var oosLabel = tier.querySelector('[data-vb-oos-label]');
                if (oosLabel) oosLabel.hidden = variantAvailable;
                var radio = tier.querySelector('.volume-bundle__radio-input');
                if (radio) radio.disabled = !variantAvailable;
               }
               var qty = parseInt(tier.dataset.quantity, 10) || 1;
               var discount = parseFloat(tier.dataset.discount) || 0;

               var mainTotal = unitPrice * qty;
               var mainCompare = unitCompare * qty;
               if (discount > 0) {
                mainTotal = Math.round(mainTotal * (1 - discount / 100));
               }

               var comboExtra = parseInt(tier.dataset.comboExtra, 10) || 0;
               var comboExtraCompare = parseInt(tier.dataset.comboExtraCompare, 10) || 0;
               var lineTotal = mainTotal + comboExtra;
               var compareTotal = mainCompare + comboExtraCompare;

               var priceEl = tier.querySelector('[data-vb-price]');
               var compareEl = tier.querySelector('[data-vb-compare]');
               var eachEl = tier.querySelector('[data-vb-each]');
               var comboMainPriceEl = tier.querySelector('[data-vb-combo-main-price]');
               var comboMainCompareEl = tier.querySelector('[data-vb-combo-main-compare]');

               // money_format can contain markup (e.g. <span class=money>…</span>),
               // so insert as HTML rather than text.
               if (priceEl) priceEl.innerHTML = self.formatMoney(lineTotal);
               if (compareEl) {
                compareEl.innerHTML = self.formatMoney(compareTotal);
                compareEl.classList.toggle('hidden', compareTotal <= lineTotal);
               }
               if (eachEl) eachEl.innerHTML = self.formatMoney(Math.round(mainTotal / qty));
               if (comboMainPriceEl) comboMainPriceEl.innerHTML = self.formatMoney(mainTotal);
               if (comboMainCompareEl) comboMainCompareEl.innerHTML = self.formatMoney(mainCompare);
              });

              // If the selected tier just went out of stock, move selection.
              var selectedTier = this.querySelector('[data-vb-tier].is-selected');
              if (selectedTier && !this.selectable(selectedTier)) {
               var fallbackTier = this.tiers.find(this.selectable.bind(this));
               if (fallbackTier) this.select(fallbackTier, true);
              }
             }

             formatMoney(cents) {
              var value = (cents / 100).toFixed(2);
              var format = this.moneyFormat;
              if (format.indexOf('amount_no_decimals') !== -1) {
               value = Math.round(cents / 100).toString();
              } else if (format.indexOf('amount_with_comma_separator') !== -1) {
               value = value.replace('.', ',');
              }
              var parts = value.split(/[.,]/);
              var sep = value.indexOf(',') !== -1 ? '.' : ',';
              parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep);
              value = parts.join(value.indexOf(',') !== -1 ? ',' : '.');
              return format.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, value);
             }
            }
           );
          }
